import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { filter, switchMap, take, map } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  return authService.initialized$.pipe(
    filter(initialized => initialized),
    take(1),
    switchMap(() => authService.isAuthenticated$),
    take(1),
    map(isAuthenticated => {
      if (isAuthenticated) {
        return true;
      }
      authService.initiateOIDCLogin();
      return false;
    }),
  );
};
